import React from "react";
import clsx from "clsx";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import ScrollSyncPanel from "components/ScrollSync/ScrollSyncPanel/ScrollSyncPanel";
import TableRow from "../TableRow";
import VerticalDivider from "../VerticalDivider";
import {
  getSurfaceContentRowModel,
  getBackgroundColor,
  parseInventoryAnalyticsClass,
  ESurfaceType,
  IRowData,
  surfaceTypes
} from "../helper";
import useCommonStyles from "../styles";
import useStyles from "./styles";

interface IProps {
  data: racehorse360.IInventoryAnalyticsBucket[];
}

const TableContent = (props: IProps) => {
  const { data } = props;
  const classes = useStyles();
  const commonClasses = useCommonStyles();
  const { dirt, turfAndSynthetic } = surfaceTypes;

  const renderSubclasses = (
    classIndex: number,
    subclasses: racehorse360.IInventoryAnalyticsRaceSubclass[]
  ) =>
    subclasses.map(subCl => (
      <div
        key={subCl.subclass + classIndex}
        className={clsx(
          commonClasses.cell,
          getBackgroundColor(classIndex, classes)
        )}
      >
        {subCl.subclass}
      </div>
    ));

  const renderFixedColumns = () => {
    return data.map((cl, index) => {
      return (
        <div key={index} className={commonClasses.colorGroupFixedCells}>
          <div
            className={clsx(
              classes.unitedCell,
              getBackgroundColor(index, classes)
            )}
          >
            {parseInventoryAnalyticsClass(cl.class)}
          </div>

          <div className={commonClasses.flexColumn}>
            {renderSubclasses(index, cl.subclasses)}
          </div>
        </div>
      );
    });
  };

  const renderRowsContent = () => {
    return data.map((cl, index) => {
      return cl.subclasses.map(subCl => {
        const surfaces = [
          {
            type: ESurfaceType.DIRT,
            data: getSurfaceContentRowModel(subCl, dirt.dataField)
          },
          {
            type: ESurfaceType.TURF_AND_SYNTHETIC,
            data: getSurfaceContentRowModel(subCl, turfAndSynthetic.dataField)
          }
        ];
        const data: IRowData = {
          backgroundClassName: getBackgroundColor(index, classes),
          totalCount: subCl.totalCount,
          surfaces
        };

        return <TableRow key={subCl.subclass} data={data} />;
      });
    });
  };

  return (
    <div className={classes.tableContent}>
      <div className={clsx(commonClasses.leftFixedColumns, classes.gap)}>
        {renderFixedColumns()}
      </div>

      <ScrollSyncPanel className={commonClasses.scrollableContent}>
        <VerticalDivider className={commonClasses.horseNumberDivider} />
        <VerticalDivider className={commonClasses.surfaceDivider} />

        {renderRowsContent()}
      </ScrollSyncPanel>
    </div>
  );
};

export default TableContent;
